import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ConfirmModal } from "../../boxes/ConfirmModal/ConfirmModal";
import styles from "./styles.module.scss";
import { useCurrentAccountQuery } from "../../api/queries/useAccountQuery";
import { WORKSPACE_STATUS } from "../../consts/api";

const Account2FaRequiredModal = ({ isAccount2FaEnabled, history }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { data: account } = useCurrentAccountQuery();

  React.useEffect(() => {
    if (
      !isAccount2FaEnabled &&
      account?.globalSettings?.accountStatus === WORKSPACE_STATUS.active
    ) {
      setIsModalOpen(true);
    }
  }, [isAccount2FaEnabled, account?.globalSettings?.accountStatus]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    history.push("/logout");
  };

  const onConfirm = () => {
    closeModal();
    history.push("/settings/profile");
  };

  return (
    isModalOpen && (
      <ConfirmModal
        isOpen={isModalOpen}
        withAlertIcon
        title="Security Update Required"
        onConfirm={onConfirm}
        onClose={closeModal}
        onCancel={handleCancel}
        confirmTitle="Setup"
      >
        <div>
          <p>
            Starting now, 2FA is mandatory for all users to help enhance
            security. You will be redirected to the user settings, setup is
            quick and straightforward!{" "}
            <a
              href="https://learn.aestheticrecord.com/en/articles/12332987-turn-on-2fa-two-factor-authentication"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              Learn more
            </a>
          </p>
        </div>
      </ConfirmModal>
    )
  );
};

function mapStateToProps(state) {
  return {
    isAccount2FaEnabled: state.AccountHoldRedirectReducer.isAccount2FaEnabled,
  };
}

export default connect(mapStateToProps)(withRouter(Account2FaRequiredModal));
